import React from "react";
import "./Common_Back_Btn.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";

const Common_Back_Btn = ({backText}) => {
  return (
    <div className="Common_Back_Btn">
      <FontAwesomeIcon icon={faAngleLeft} className="back_icon" /> {backText}
    </div>
  );
};

export default Common_Back_Btn;
